import React, { useState } from 'react';
import { isEmpty } from 'ramda';
import { useParams } from 'react-router-dom';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

// tools
import getDateFromISOstring from '../../../../../../helpers/getDateFromISOstring';

// store
import { storeSet, useStoreValue } from '../../../../../../store';

// components
import VideoIcon from '../../../../../../icons/VideoIcon';
import TripleDotsIcon from '../../../../../../icons/TripleDotsIcon';
import PlusIcon from '../../../../../../icons/PlusIcon';
import ModalUploadVideo from '../../../../../../components/ModalUploadVideo';
import ButtonIconContextMenu from '../../../../../../components/ButtonWrapper/components/ButtonIconContextMenu';
import formatDuration from '../../../../../../helpers/formatDuration';

const VideoList = () => {
    const { projectId } = useParams();
    const myStudioLeftPanel = useStoreValue('myStudioLeftPanel');
    const projectVideos = useStoreValue('projectVideos');
    const [showUploadModal, setShowUploadModal] = useState(false);

    const handleVideoDelete = (id) => {
        storeSet('deleteVideoItem', projectId, id)
    }

    return (
        myStudioLeftPanel === 'video'
            ? <>
                <OverlayScrollbarsComponent element="div" options={{ scrollbars: { autoHide: 'never' } }} defer>
                <ul className="timelineEditorAuxControls__listOfVideos">
                    {projectVideos && !isEmpty(projectVideos)
                        ? projectVideos.map(item => <li key={`video_${item.id}`}>
                            {item.thumbnailUrl
                                ? <picture>
                                    <img src={item.thumbnailUrl} alt="video thumb"/>
                                </picture>
                                : <div className="videoPlaceholder">
                                    <VideoIcon/>
                                </div>}
                            <div className="title">
                                <h3>{item.name}</h3>
                                <span>{formatDuration(item.duration)}</span>
                            </div>
                            <div className="meta lastGroup">
                        <span>{getDateFromISOstring(item.date, {
                            day: '2-digit',
                            month: 'short'
                        })}</span>
                                <ButtonIconContextMenu menuItems={[{ label: 'Cancella', onClick: () => handleVideoDelete(item.id) }]}>
                                    <TripleDotsIcon/>
                                </ButtonIconContextMenu>
                            </div>
                        </li>) : null}
                </ul>
                </OverlayScrollbarsComponent>
                <button className="timelineEditorAuxControls__addNew" onClick={() => setShowUploadModal(true)}>
                    <PlusIcon/>
                </button>
                {showUploadModal && (
                    <ModalUploadVideo
                        projectId={projectId}
                        onClose={() => setShowUploadModal(false)}
                    />
                )}
            </> : null
    );
};

export default VideoList;
